import React from 'react';

/**
 * Spinner
 *
 * Shared loading indicator. Import this everywhere — never define a local one.
 *
 * Sizes: sm | md | lg
 *
 * Usage:
 *   <Spinner />
 *   <Spinner size="sm" />
 *   <Spinner className="text-white" />
 */

const sizes = {
  sm: 'h-3 w-3',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
};

export function Spinner({ size = 'md', className = '' }) {
  return (
    <svg
      className={['animate-spin shrink-0', sizes[size], className].filter(Boolean).join(' ')}
      viewBox="0 0 24 24"
      fill="none"
      aria-label="Loading"
      aria-hidden="true"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
    </svg>
  );
}

export default Spinner;
